import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { InvoiceTracking } from "./Table";
import { Dialog } from "primereact/dialog";
import { Fetch } from "../../shared/Fetch";
import { format } from "date-fns";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { JVInput } from "../../shared/JVInput";
import { Card } from "primereact/card";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    open: boolean;
    onClose: () => void;
    toast: any;
    singleDate: InvoiceTracking;
}

interface IFollowUpCallHistory {
    id?: number,
    callCount?: number,
    calledByName?: string,
    calledBy?: number,
    calledOn?: Date,
    callFeedback?: string,
    invoice_ID?: number,
}

const schema = yup.object({
    callFeedback: yup.string().required("FeedBack is required"),
});

export const FollowUpCallHistory = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IFollowUpCallHistory[], loading: boolean });
    const [selectedRow, setSelectedRow] = useState({ singleData: {}, open: false } as { singleData: IFollowUpCallHistory, open: boolean });
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<IFollowUpCallHistory>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onHide = () => {
        reset({ callFeedback: "" });
        props.onClose();
    }

    const onSubmit = async (data: IFollowUpCallHistory) => {
        setLoading(true);
        const response = await Fetch("InvoiceTracking/updateFollowUpCallHistory", "POST", data, `invoice_ID=${props.singleDate.invoice_ID}`, props.toast);
        if (response) {
            setLoading(false);
            props.toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Follow Up Call History Added Successfully' });
            reset({ callFeedback: "" });
            loadTableData();
        } else {
            setLoading(false);
            props.toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to Add Follow Up Call History' });
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/followUpHistory", "GET", null, `invoice_ID=${props.singleDate.invoice_ID}&type='call'`, props.toast);
        if (response) {
            const data: IFollowUpCallHistory[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const sendOnDate = (rowData: any) => {
        let date;
        if (rowData.calledOn) date = format(new Date(rowData.calledOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        if (props.open && props.singleDate.invoice_ID) {
            loadTableData();
        }
    }, [props.open]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <>
            <Dialog style={{ width: '70vw' }} visible={props.open} onHide={() => onHide()} header="Payment Follow Up Call History" >
                <Card title="Add New Call Record :" className="mb-3">
                    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                        <JVInput required column={2} label="Feedback" control={control} name="callFeedback" error={errors.callFeedback?.message} />
                        <div className="col-12 md:col-6 flex gap-4 justify-content-end">
                            <Button loading={loading} disabled={loading} label="SAVE" type={loading === false ? "submit" : "button"} style={{ width: '100px', height: "2.5rem", marginTop: "2rem" }} ></Button>
                            <Button className="p-button-outlined surface-200" style={{ width: '100px', height: "2.5rem", marginTop: "2rem" }} label="CLEAR" onClick={() => reset({ callFeedback: "" })} type="button" ></Button>
                        </div>
                    </form>
                </Card>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    value={tableData.tableData}
                    loading={tableData.loading}
                    dataKey="id"
                    paginator
                    rows={100}
                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="calledByName" header="Call Done By" />
                    {/* <Column field="calledOn" header="Called On" body={sendOnDate} /> */}
                    <Column field="calledOn" header="Called On" body={(rowData: any) => safeFormatDate(rowData.calledOn, 'dd/MM/yyyy', DateFormat)} />
                    <Column field="feedBack" header="FeedBack" body={(rowData) => <p className="cursor-pointer underline text-primary" style={{ maxWidth: "12rem", textOverflow: "ellipsis" }} onClick={() => setSelectedRow({ singleData: rowData, open: true })}>FeedBack</p>} />
                    <Column header="Action" body={(rowData: IFollowUpCallHistory) => <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => reset(rowData)} />} />
                </DataTable>
            </Dialog>
            <Dialog style={{ width: '70vw' }} visible={selectedRow.open} onHide={() => setSelectedRow({ singleData: { callFeedback: "" }, open: false })} header="Feedback" >
                <CKEditor editor={ClassicEditor} data={selectedRow.singleData?.callFeedback} />
            </Dialog>
        </>
    );
}